import React from 'react';
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
  Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCatalogContext } from './CatalogContext';
import { useGetFilters } from '../../../../client/hooks/marketplace/marketplace.queries';

const CatalogFilterDrawer = () => {
  const {
    drawerOpen,
    handleDrawerToggle,
    filters,
    handleFilterChange,
    handleResetFilters,
    handleSearch
  } = useCatalogContext();

  const { data, isLoading } = useGetFilters(true);
  const categorias = data?.categories || [];

  return (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={handleDrawerToggle}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: 400 },
          padding: 2,
          bgcolor: '#fafafa'
        }
      }}
    >
      <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6" fontWeight={600}>
            Filtros Avançados
          </Typography>
          <IconButton onClick={handleDrawerToggle} edge="end">
            <CloseIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, mb: 2, flexGrow: 1, overflow: 'auto' }}>
          <FormControl fullWidth size="small">
            <InputLabel>Categoria</InputLabel>
            <Select
              name="categoria"
              value={filters.categoria}
              onChange={handleFilterChange}
              label="Categoria"
            >
              <MenuItem value="">Todas as Categorias</MenuItem>
              {categorias.map(categoria => {
                let value = categoria.id || categoria.name || categoria;
                let label = categoria.name || categoria;
                if (typeof label === 'string') {
                  label = label
                    .toLowerCase()
                    .replace(/_/g, ' ')
                    .replace(/\b\w/g, l => l.toUpperCase());
                }
                return (
                  <MenuItem key={value} value={value}>
                    {label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              fullWidth
              label="Preço Mínimo"
              name="precoMin"
              value={filters.precoMin}
              onChange={handleFilterChange}
              size="small"
              type="number"
              InputProps={{
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                inputProps: { min: 0 }
              }}
            />
            <TextField
              fullWidth
              label="Preço Máximo"
              name="precoMax"
              value={filters.precoMax}
              onChange={handleFilterChange}
              size="small"
              type="number"
              InputProps={{
                startAdornment: <InputAdornment position="start">R$</InputAdornment>,
                inputProps: { min: 0 }
              }}
            />
          </Box>

          <FormControl fullWidth size="small">
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              label="Status"
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="ativo">Ativos</MenuItem>
              <MenuItem value="inativo">Inativos</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small">
            <InputLabel>Estoque</InputLabel>
            <Select
              name="estoque"
              value={filters.estoque}
              onChange={handleFilterChange}
              label="Estoque"
            >
              <MenuItem value="todos">Todos</MenuItem>
              <MenuItem value="disponivel">Disponível</MenuItem>
              <MenuItem value="baixo">Estoque Baixo</MenuItem>
              <MenuItem value="indisponivel">Indisponível</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            fullWidth
            variant="outlined"
            onClick={handleResetFilters}
            sx={{
              color: 'text.secondary',
              borderColor: '#e0e0e0',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                borderColor: '#d0d0d0'
              }
            }}
          >
            Limpar
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSearch}
            sx={{
              bgcolor: "#f7d0bf",
              color: "black",
              fontWeight: 600,
              "&:hover": { bgcolor: "#f5c1a9" },
            }}
          >
            Aplicar Filtros
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default CatalogFilterDrawer;
